var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCurvedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 73,
    viewBox: "0 0 177 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81773 23.5959C5.36969 16.6822 27.3683 3.85716 36.6105 2.54777C61.026 -0.91149 88.8616 4.58353 103.989 22.0088C106.425 24.8161 110.279 31.1671 111.416 34.7286C121.244 65.5544 66.881 57.6143 82.9081 32.0782C84.7561 29.1341 88.3185 26.4794 91.4986 25.0604C116.825 13.7598 147.168 39.1968 161.255 53.5263C164.613 56.9408 173.953 65.8101 172.565 71.7464C172.48 72.1154 173.042 65.6608 171.992 62.8959C171.75 62.2615 170.65 60.7961 171.353 60.9564C173.482 61.4416 176.971 69.8852 174.697 71.7205C173.783 72.4587 165.745 66.7891 164.909 66.4109",
    stroke: "#F3AA47",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurvedIn);
export default __webpack_public_path__ + "static/media/arrow-curved-in.95be106730c7a978dd6e74d3f0ff2bd8.svg";
export { ForwardRef as ReactComponent };